import { w3cwebsocket as W3CWebSocket } from 'websocket';

const RECONNECT_DELAY_MS = 5000;
const IDENTITY_RETRY_MS = 500;

export class DispatchSocketService {
    constructor(wsUrl, onNotification) {
        this._wsUrl = wsUrl;
        this._onNotification = onNotification;
        this._socket = null;
        this._reconnectTimer = null;
        this._intentionalClose = false;
    }

    connect() {
        this._intentionalClose = false;
        this._openSocket();
    }

    disconnect() {
        this._intentionalClose = true;
        clearTimeout(this._reconnectTimer);
        if (this._socket) {
            this._socket.onclose = null;
            this._socket.close();
            this._socket = null;
        }
    }

    _openSocket() {
        if (!this._wsUrl) return;
        try {
            const url = this._wsUrl.replace(/\/?$/, '/') + 'Connect';
            this._socket = new W3CWebSocket(url);

            this._socket.onopen = () => this._sendIdentity();

            this._socket.onerror = (error) => {
                console.error('[DispatchSocket] Connection error:', error);
                // onclose will fire next and schedule reconnect
            };

            this._socket.onclose = (event) => {
                if (!this._intentionalClose) {
                    console.warn(`[DispatchSocket] Disconnected (code: ${event.code}). Reconnecting in ${RECONNECT_DELAY_MS / 1000}s...`);
                    this._reconnectTimer = setTimeout(() => this._openSocket(), RECONNECT_DELAY_MS);
                }
            };

            this._socket.onmessage = (message) => {
                if (!message.data) return;
                try {
                    const notification = JSON.parse(message.data);
                    if (
                        notification.DisableDisplayNotification &&
                        notification.AccountId === parseInt(sessionStorage.getItem('session_accountId')) &&
                        notification.LocationId === parseInt(sessionStorage.getItem('session_locationId'))
                    ) {
                        this._onNotification(notification);
                    }
                } catch {
                    // malformed message — discard silently
                }
            };
        } catch (error) {
            console.error('[DispatchSocket] Failed to create socket:', error);
            if (!this._intentionalClose) {
                this._reconnectTimer = setTimeout(() => this._openSocket(), RECONNECT_DELAY_MS);
            }
        }
    }

    _sendIdentity() {
        const attempt = () => {
            if (!this._socket) return;
            if (this._socket.readyState === this._socket.OPEN) {
                this._socket.send(JSON.stringify({
                    user: {
                        UserName: sessionStorage.getItem('session_userName'),
                        AccountId: parseInt(sessionStorage.getItem('session_accountId')),
                        LocationId: parseInt(sessionStorage.getItem('session_locationId')),
                    },
                }));
            } else {
                setTimeout(attempt, IDENTITY_RETRY_MS);
            }
        };
        attempt();
    }
}
